import React from "react";
import { MdOutlineDragIndicator } from "react-icons/md";
import { FiTrash2 } from "react-icons/fi";

const CATEGORIES = {
  politic: "Քաղաքական",
  social: "Սոցիալական",
  economic: "Տնտեսական",
  prophetic: "Մարգարեական",
  finance: "Ֆինանսական",
  sport: "Սպորտային",
  scientific: "Գիտական",
};

const Template = ({ item, provided, deleteItem }) => {
  const itemCategories = Array.isArray(item.categories)
    ? item.categories
    : [item.category].filter(Boolean);

  const imageSrc =
    item.predictor?.image || item.image || "/defaultuserprofile.webp";

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      className="flex items-center justify-between gap-3 bg-white border border-slate-200/80 hover:border-slate-300 rounded-2xl p-3 my-2.5 shadow-xs hover:shadow-sm transition-all group"
    >
      {/* Drag handle */}
      <div
        {...provided.dragHandleProps}
        className="p-1.5 text-slate-300 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition cursor-grab active:cursor-grabbing shrink-0"
        title="Տեղափոխել հերթականությունը"
      >
        <MdOutlineDragIndicator size={20} />
      </div>

      {/* Item Content & Thumbnail */}
      <div className="flex items-center gap-4 flex-1 min-w-0">
        <div className="relative w-24 h-20 sm:w-28 sm:h-20 rounded-xl overflow-hidden bg-slate-100 border border-slate-200/60 shrink-0">
          <img
            className="w-full h-full object-cover"
            src={imageSrc}
            alt={item.title || "Նկար"}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/defaultuserprofile.webp";
            }}
          />
          {itemCategories.length > 0 && (
            <span className="absolute bottom-1 left-1 px-1.5 py-0.5 rounded-md text-[9px] font-bold bg-slate-900/80 text-white backdrop-blur-xs">
              {CATEGORIES[itemCategories[0]] || itemCategories[0]}
            </span>
          )}
        </div>

        <div className="flex flex-col min-w-0 flex-1">
          <h4 className="text-sm font-bold text-slate-900 truncate">
            {item.title || "Անվերնագիր"}
          </h4>
          {item.description ? (
            <p className="text-xs text-slate-500 line-clamp-2 mt-0.5 leading-relaxed">
              {item.description}
            </p>
          ) : (
            <span className="text-[11px] text-slate-400 mt-0.5">
              {item.author?.displayName || item.site || "Գլխավոր էջի նյութ"}
            </span>
          )}
        </div>
      </div>

      {/* Delete button */}
      <button
        type="button"
        onClick={() => deleteItem(item.id)}
        className="p-2 text-slate-400 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition cursor-pointer shrink-0"
        title="Հեռացնել ցանկից"
      >
        <FiTrash2 size={16} />
      </button>
    </div>
  );
};

export default Template;
